import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import './BikePackage.css';
import { Facebook, Instagram, Twitter } from "lucide-react";
import Bike2 from "../../../assets/Images/bike2.png";
import Nav from "../Nav";
import Footer from "../Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Seo from "../../Seo/Seo";
import { useSeoMeta } from "../../Seo/useSeoMeta";
import { SITE_NAME } from "../../Seo/seoConfig";
import b from "../../../assets/Images/Ellipse 4017.png";
import g from "../../../assets/Images/Ellipse 4018.png";
import t from "../../../assets/Images/Ellipse 4019.png";

const BikePackage = () => {
  const centralizedSeo = useSeoMeta();
  const [bikePackages, setBikePackages] = useState([]);
  const [hotelPackages, setHotelPackages] = useState([]);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}AllPackages`);
        const result = await response.json();

        const allPackages = result?.data || [];
        const filteredBikes = allPackages.filter(pkg =>
          pkg?.category?.name?.toLowerCase().includes("bike")
        );
        console.log("filteredBikes-", filteredBikes);
        setBikePackages(filteredBikes || []);

        const filteredHotels = allPackages
          .filter(pkg =>
            pkg?.category?.name?.toLowerCase() === "hotels"
          )
          .slice(0, 4);
        setHotelPackages(filteredHotels);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages();
  }, []);
  const navigate = useNavigate();

  const images = [b, g, t];

  return (
    <div className="container-fluid p-0">
      <Seo
        title={`Ladakh Bike Tour Packages | ${SITE_NAME}`}
        description={`Explore Ladakh bike trip packages with ${SITE_NAME} - itineraries, pricing and routes for your Leh Ladakh motorcycle expedition.`}
        centralizedSeo={centralizedSeo}
        type="website"
      />
      <Nav />
      {bikePackages.map((bike, index) => (
        <section key={index} className="position-relative w-100" style={{ height: '750px' }}>
          <img
            src={bike?.image?.[0] || '/placeholder.jpg'}
            alt={bike?.name || "Bike Adventure"}
            className="img-fluid main-road-img w-100 h-100 object-fit-cover"
            style={{ objectFit: 'cover' }}
          />

          <div className="position-absolute explore-card h-100 d-flex flex-column justify-content-center px-4 px-md-5 text-black" >
            <div >
              {index === 0 && (
                <p className="small text-white mb-2">The Adventure of Your Life</p>
              )}
              <h2 className="text-white fw-bold">
                {bike?.name || "Bike Tour Adventure"}
              </h2>
              <br />
              <button
                style={{
                  borderRadius: "20px",
                  border: "none",
                  color: "white",
                  backgroundColor: "brown",
                  padding: "16px",
                  fontWeight: "bold",
                  cursor: "pointer"
                }}
                onClick={() => navigate(`/detail-bike-package/${bike.name?.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`)}
              >
                Explore Now
              </button>
            </div>

            <div className="d-flex align-items-center gap-3 mt-4">
              <div className="d-flex gap-2">
                <Facebook size={16} color="white" />
                <Instagram size={16} color="white" />
                {/* <Twitter size={16} color="white" /> */}
              </div>
              <div className="small text-white">
                <strong>1.8M</strong> Views
              </div>
            </div>
          </div>

          {bike?.intinerary_details && (
            <div
              className="position-absolute bottom-0 start-0 end-0 px-4 px-md-5 pb-4"
              style={{ zIndex: 10 }}
            >
              <div className="d-flex moving-cards-container justify-content-between align-items-end w-100">
                {/* Left Testimonial Card */}
                <div
                  className="glass-card text-dark me-3"
                  style={{
                    borderRadius: "16px",
                    backdropFilter: "blur(12px)",
                    background: "rgba(255, 255, 255, 0.25)",
                    padding: "16px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    width: "360px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      {images.map((imgSrc, i) => (
                        <div
                          key={i}
                          className="rounded-circle overflow-hidden"
                          style={{
                            width: "36px",
                            height: "36px",
                            border: "2px solid #ccc",
                            marginLeft: i === 0 ? 0 : "-16px",
                            zIndex: 10 - i,
                          }}
                        >
                          <img
                            src={imgSrc}
                            alt={`user-${i}`}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                          />
                        </div>
                      ))}
                    </div>

                    {/* Button + Text */}
                    <div className="d-flex align-items-center gap-3">
                      <button
                        className="btn btn-dark"
                        style={{
                          borderRadius: "999px",
                          padding: "6px 16px",
                          fontSize: "0.875rem",
                        }}
                      >
                        2k Plus
                      </button>
                      <p className="mb-0 fw-semibold" style={{ color: "#333" }}>
                        Trusted
                      </p>
                    </div>
                  </div>

                  {/* Testimonial Text */}
                  <div style={{ textAlign: "center" }}>
                    <p className="mb-0" style={{ color: "#333", fontSize: "0.95rem" }}>
                      Unforgettable ride through Ladakh's beauty, thrill, and peace.
                    </p>
                  </div>
                </div>

                {/* Right-side Itinerary Cards */}
                <div class="move-card">
                  <Slider
                    dots={false}
                    arrows={false}
                    infinite={true}
                    speed={500}
                    slidesToShow={1}
                    slidesToScroll={1}
                    autoplay={true}
                    autoplaySpeed={4000}
                  >
                    {bike.intinerary_details.map((item, idx) => (
                      <div key={idx} className="pe-3">
                        <div
                          className="glass-card text-dark"
                          style={{
                            borderRadius: "16px",
                            backdropFilter: "blur(12px)",
                            background: "rgba(255, 255, 255, 0.25)",
                            padding: "0 16px",
                            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                            minHeight: "160px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          {/* Image Column */}
                          {item[2] && (
                            <img
                              src={item[2]}
                              alt={item[0]}
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "12px",
                                flexShrink: 0,
                              }}
                            />
                          )}

                          {/* Text Column */}
                          <div style={{ flex: 1 }}>
                            <h4
                              className="fw-bold mb-1"
                              style={{
                                fontSize: "0.95rem",
                                whiteSpace: "wrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              title={item[0]}
                            >
                              {item[0]}
                            </h4>
                            <p
                              className="small mb-0"
                              style={{
                                color: "#333",
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                lineHeight: "1.2",
                              }}
                              title={item[1]}
                            >
                              {item[1] || item[0]?.split(' ').length > 10
                                ? item[1].split(' ').slice(0, 12).join(' ') + '...'
                                : item[1]}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>

              </div>
            </div>
          )}
        </section>
      ))}
      {/* Stats Section */}
      <section className="py-5 px-4 px-md-5 mt-5">
        {/* First Row: Heading + Two Paragraphs */}
        <div className="row g-4 align-items-start">
          {/* Left: Heading */}
          <div className="col-md-6">
            <h1 className="h2 fw-bold mb-3">From Valleys to Vistas—Ladakh’s Calling You to Ride</h1>
          </div>

          {/* Right: Two Paragraphs side by side */}
          <div className="col-md-6">
            <div className="row g-3">
              <div className="col-6">
                <p className="small text-muted">
                  Summer turns Ladakh into a living postcard. Biking here means chasing golden horizons, meeting ancient traditions, and gliding past turquoise lakes. The roads invite you to explore deeply, from cultural wonders to untouched landscapes. Every ride brings peace, perspective, and stories you’ll retell forever.
                </p>
              </div>
              <div className="col-6">
                <p className="small text-muted">
                  In the heart of summer, Ladakh becomes a rider’s paradise—where every mile offers a new shade of serenity. As you bike through its winding mountain roads, prayer flags flutter beside you and the scent of crisp alpine air fills your lungs.
                </p>
              </div>
            </div>
          </div>
        </div>
        <section className="py-5 px-4 px-md-5 bg-white">
          <div className="row gx-0">
            {["Adventure Tours", "Destinations", "Years Experience", "Luxury Resorts"].map((text, i) => (
              <div
                key={i}
                className={`col-6 col-md-3 position-relative clean-border ${i < 3 ? "with-right" : ""}`}
              >
                <div className="p-4 text-center">
                  <p className="h3 fw-bold mb-1">10+</p>
                  <p className="small m-0 text-muted">{text}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

      </section>

      {/* Explore More Section */}
      <section className="py-5 px-4 px-md-5 bg-light">
        <h3 className="h4 fw-bold mb-4">Explore More Resorts</h3>
        <div className="row g-4">
          {hotelPackages.map((hotel, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3">
              <div
                className="rounded overflow-hidden h-100 d-flex flex-column"
                style={{
                  padding: "10px",
                  borderRadius: "5px"
                }}
              >
                {/* Image */}
                <div className="position-relative" style={{ height: "200px" }}>
                  <img
                    src={hotel?.image?.[0] || "/placeholder.svg?height=300&width=400"}
                    alt={hotel?.name || "Hotel"}
                    className="img-fluid w-100 h-100 object-fit-cover"
                    style={{ objectFit: "cover", borderRadius: "15px" }}
                  />
                  <div
                    className="position-absolute bottom-0 start-0 end-0 p-2 text-white"
                  >
                  </div>
                </div>

                {/* Text Content */}
                <div className="p-3 d-flex flex-column justify-content-between flex-grow-1">
                  <h4 className="fw-bold text-dark mb-2" style={{ fontSize: "1rem" }}>
                    {hotel?.name || "Unnamed Resort"}
                  </h4>
                  <p
                    className="text-muted small mb-2"
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      lineHeight: "1.4",
                    }}
                  >
                    {hotel?.location || "No location provided"}
                  </p>
                  <button className="btn btn-outline-dark btn-sm mt-auto"
                    onClick={() => navigate('/hotel-package')}>
                    View More</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
 
      {/* <div className="position-fixed bottom-0 end-0 m-4">
        <button
          className="btn btn-light rounded-circle shadow"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
            <path d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" />
          </svg>
        </button>
      </div> */}

      <Footer />
    </div>
  );
};
export default BikePackage;
